import React, { useEffect } from 'react'
import { generatePath, Navigate } from 'react-router'

import { useRequest } from '../hooks/request'
import {
  gridSave, gridPublishPath, gridPublish,
} from '../requests/grid'
import { PATHS } from '../constants/paths'
import { useGenericStorage } from '../data/GenericStorageContext'

import { PageTitle } from './common/PageTitle'
import { PageContent } from './layout/layout'
import { GridForm } from './GridForm'

const createDocumentCreate = ({
  saveRequest,
  publishRequest,
  title,
  redirectPath,
  publishPath,
  Form,
  backLink,
  backLinkTrad,
}) => () => {
  const { genericStorage, mergeIntoGenericStorage } = useGenericStorage()
  const { gridToDuplicate } = genericStorage
  const initialValues = gridToDuplicate || { name: '', grades: [{ text: '' }], blocks: [] }
  useEffect(() => () => mergeIntoGenericStorage({ gridToDuplicate: null }), [])
  const documentSaveRequest = useRequest({
    request: saveRequest,
  })

  const documentPublishRequest = useRequest({
    request: publishRequest,
  })

  const publicationSuccess = documentPublishRequest.state.success
  const saveSuccess = documentSaveRequest.state.success
  const success = publicationSuccess || saveSuccess
  const newDocument = documentSaveRequest.state.data || documentPublishRequest.state.data

  return (
    <>
      <PageTitle tradId={title} backLink={backLink} backLinkTrad={backLinkTrad} />
      <PageContent>
        {
          success ? (
            <Navigate to={generatePath(redirectPath, { id: newDocument.id })} push />
          ) : (
            <Form
              initialValues={initialValues}
              onSave={documentSaveRequest.fetch}
              onSubmit={documentPublishRequest.fetch}
              path={publishPath}
              saveLoading={documentSaveRequest.state.loading}
              publishLoading={documentPublishRequest.state.loading}
            />
          )
        }
      </PageContent>
    </>
  )
}


export const GridCreate = createDocumentCreate({
  title: 'gridCreate',
  saveRequest: gridSave,
  Form: GridForm,
  publishRequest: gridPublish,
  redirectPath: PATHS.GRID_EDIT,
  publishPath: gridPublishPath,
  backLink: PATHS.GRID_LIST,
  backLinkTrad: 'gridList',
})
